import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';
import { isIE11 } from '../detect-ie11';

@Directive({ selector: '[appShowIE11]' })
export class IE11ShowDirective implements OnInit {
  constructor(public el: ElementRef, public renderer: Renderer2) {}

  ngOnInit() {
    // detect ie11
    if (!isIE11()) {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    }
  }
}
